import { render, staticRenderFns } from "./DashboardWidgetStore.vue?vue&type=template&id=14632184&scoped=true"
import script from "./DashboardWidgetStore.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetStore.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidgetStore.vue?vue&type=style&index=0&id=14632184&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14632184",
  null
  
)

export default component.exports